import {yupResolver} from '@hookform/resolvers/yup'
import {FC} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {Panel, PanelGroup} from 'react-resizable-panels'
import {Button, ButtonWrapper} from '../../../../../components/UI/Button'
import {useLimpieza} from '../../../../../hooks/useLimpieza'
import {newAssignmentCleaningSchedulesSchema} from '../../../../../util/validationLimpieza'
import {ResizeHandle} from '../../../../limpieza/components/Layout/Container/ResizeHandle/ResizeHandle'
import {AssigmentProvider, useAssigment} from '../../../hooks/limpieza/useAssigment'
import {SearchAssigmentModel} from '../../../model/assigment.model'
import ContainerWrapper from '../../componentes/Container'
import {renderPanelContent} from '../components'

const AssignmentCleaningSchedulesPage: FC = () => {
  const {currentTabItem} = useLimpieza()
  const {getLayout, setSelectedSchedulesFn} = useAssigment()

  const methods = useForm<SearchAssigmentModel>({
    resolver: yupResolver(newAssignmentCleaningSchedulesSchema),
    defaultValues: {
      CompaniaId: '',
      ClienteId: '',
      SiteId: '',
      TipoData: '',
      TipoEdificacionId: '',
      CamaId: '',
      CampamentoId: '',
      HabitacionId: '',
      ModuloId: '',
      PisoId: '',
      CompaniaNombre: '',
      ClienteNombre: '',
      SiteNombre: '',
      TipoEdificacionNombre: '',
      CampamentoNombre: '',
      ModuloNombre: '',
      PisoNombre: '',
      HabitacionNombre: '',
      CamaNombre: '',
      EsAsignado: false,
    },
  })

  const handleAssigmentData = async (data: SearchAssigmentModel) => {
    data.TipoData = 'CAP'

    methods.setValue('CompaniaIdCurrent', data.CompaniaId)
    methods.setValue('ClienteIdCurrent', data.ClienteId)
    methods.setValue('SiteIdCurrent', data.SiteId)
    methods.setValue('TipoEdificacionIdCurrent', data.TipoEdificacionId)

    var requestLayout: SearchAssigmentModel = {
      CompaniaId: data.CompaniaId,
      ClienteId: data.ClienteId,
      SiteId: data.SiteId,
      TipoData: data.TipoData,
      TipoEdificacionId: data.TipoEdificacionId,
    }
    setSelectedSchedulesFn([])
    await getLayout(requestLayout)

    // var requestCelular: CellphoneDto = {
    //   pageNumber: 1,
    //   size: 1000,
    //   CompaniaId: data.CompaniaId,
    //   ClienteId: data.ClienteId,
    //   SiteId: data.SiteId,
    //   NivelAsignacion: '',
    //   EsAsignado: false,
    // }
    // await getCelularesDisponibles(requestCelular)

    // var requestActividad: CleaningActivitiesDto = {
    //   pageNumber: 1,
    //   size: 1000,
    //   CompaniaId: data.CompaniaId,
    //   ClienteId: data.ClienteId,
    //   SiteId: data.SiteId,
    // }
    // await getActividadesDisponibles(requestActividad)
  }

  const onSubmit = async (data: SearchAssigmentModel) => {
    await handleAssigmentData(data)
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <ButtonWrapper>
          <Button label='Buscar' classNameProp='ms-auto' typeBtn='submit' />
        </ButtonWrapper>
        <ContainerWrapper>
          <PanelGroup autoSaveId='example' direction='vertical' style={{height: '100%'}}>
            <Panel
              collapsible={true}
              order={1}
              key={`panel-limpieza-header-${currentTabItem.id}`}
              id={`panel-limpieza-header-${currentTabItem.id}`}
              className={'panel__box'}
            >
              <>{renderPanelContent(currentTabItem.content.headerPanel)}</>
            </Panel>
            <>
              {currentTabItem.showPanel && (
                <>
                  <ResizeHandle />
                  <Panel
                    className={'panel__box'}
                    collapsible={true}
                    defaultSize={50}
                    order={2}
                    key={`panel-limpieza-detail-${currentTabItem.id}`}
                    id={`panel-limpieza-detail-${currentTabItem.id}`}
                  >
                    {renderPanelContent(currentTabItem.content.detailPanel)}
                  </Panel>
                </>
              )}
            </>
          </PanelGroup>
        </ContainerWrapper>
      </form>
    </FormProvider>
  )
}

const AssignmentCleaningSchedulesPageWrapper: FC = () => {
  return (
    <AssigmentProvider>
      <AssignmentCleaningSchedulesPage></AssignmentCleaningSchedulesPage>
    </AssigmentProvider>
  )
}

export default AssignmentCleaningSchedulesPageWrapper
